import React, { useEffect, useRef } from "react";
import "./DailyFood.css";
import Chart from "chart.js/auto";
import { CategoryScale } from "chart.js";
Chart.register(CategoryScale);

export default function DailyFood({ carbohydrates, protein, fat }) {
  const chartRef = useRef(null);

  useEffect(() => {
    const ctx = chartRef.current.getContext("2d");
    const devicePixelRatio = 1.5;

    let chartData = [];
    if (protein && fat && carbohydrates) {
      chartData = [
        protein.consumed_protein,
        fat.consumed_fat,
        carbohydrates.consumed_carbohydrates,
      ];
    }

    const backgroundColors = ["#ff842c", "#0077ff", "#ff4545"];

    const chart = new Chart(ctx, {
      type: "pie",
      data: {
        labels: ["پروتئین", "چربی", "کربوهیدرات"],
        datasets: [
          {
            data: chartData,
            backgroundColor: backgroundColors,
          },
        ],
      },
      options: {
        devicePixelRatio: devicePixelRatio,
        plugins: {
          legend: {
            position: "bottom",
            align: "center",
            labels: {
              boxWidth: 8,
              padding: 5,
              usePointStyle: true,
              pointStyle: "circle",
            },
          },
          tooltip: {
            callbacks: {
              label: (context) => {
                const value = context.formattedValue;
                const percentage =
                  (context.dataset.data[context.dataIndex] /
                    context.dataset.data.reduce((a, b) => a + b, 0)) *
                  100;
                return `${value} (${percentage.toFixed(1)}%)`;
              },
            },
          },
        },
      },
    });

    return () => {
      chart.destroy();
    };
  }, [protein, fat, carbohydrates]);

  return (
    <div className="dailyFoodContainer centeredFlex">
      <h3 className="dailyFoodHeading">غذای روزانه</h3>
      <div className="energySources centeredFlex responsiveWidth">
        <div className="fats centeredFlex">
          <p>چربی ها</p>
          <div className="fatsTracker centeredFlex">
            {fat && (
              <span className="trackerText">
                {Number.isInteger(fat.consumed_fat)
                  ? fat.consumed_fat.toFixed(1)
                  : fat.consumed_fat.toFixed(2)}
              </span>
            )}
            {fat && (
              <div
                className="fatsProgressBar"
                style={{
                  width: `${(fat.consumed_fat / fat.total_fat) * 100}%`,
                }}
              ></div>
            )}
          </div>
          {fat ? (
            <span>
              {fat.total_fat.toFixed(1)} /{" "}
              {parseFloat(fat.consumed_fat).toFixed(1)}
            </span>
          ) : (
            <span>0/0</span>
          )}
        </div>
        <div className="carbohydrates centeredFlex">
          <p>کربوهیدرات ها</p>
          <div className="carboTracker centeredFlex">
            {carbohydrates && (
              <span className="trackerText">
                {Number.isInteger(carbohydrates.consumed_carbohydrates)
                  ? carbohydrates.consumed_carbohydrates.toFixed(1)
                  : carbohydrates.consumed_carbohydrates.toFixed(2)}
              </span>
            )}
            {carbohydrates && (
              <div
                className="carboProgressBar"
                style={{
                  width: `${
                    (carbohydrates.consumed_carbohydrates /
                      carbohydrates.total_carbohydrates) *
                    100
                  }%`,
                }}
              ></div>
            )}
          </div>
          {carbohydrates ? (
            <span>
              {carbohydrates.total_carbohydrates.toFixed(1)} /{" "}
              {parseFloat(carbohydrates.consumed_carbohydrates).toFixed(1)}
            </span>
          ) : (
            <span>0/0</span>
          )}
        </div>
        <div className="protein centeredFlex">
          <p>پروتئین</p>
          <div className="proteinsTracker centeredFlex">
            {protein && (
              <span className="trackerText">
                {Number.isInteger(protein.consumed_protein)
                  ? protein.consumed_protein.toFixed(1)
                  : protein.consumed_protein.toFixed(2)}
              </span>
            )}
            {protein && (
              <div
                className="proteinsProgressBar"
                style={{
                  width: `${
                    (protein.consumed_protein / protein.total_protein) * 100
                  }%`,
                }}
              ></div>
            )}
          </div>
          {protein ? (
            <span>
              {protein.total_protein.toFixed(1)} /{" "}
              {parseFloat(protein.consumed_protein).toFixed(1)}
            </span>
          ) : (
            <span>0/0</span>
          )}
        </div>
      </div>
      <div className="dailyFoodChart centeredFlex">
        <canvas ref={chartRef} className="customPieChart" />
      </div>
    </div>
  );
}
